import styled from 'styled-components';

const ContainerHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
`;

const DashboardWrapper = styled.div`
    .alert-banner {
        position: fixed !important; //override default styling
        z-index: 10; //overlay existing content
        width: 100%;
        top: 0;
    }
`;

const DashboardBody = styled.div`
  padding: 1% 2%;
`;

const DashboardTable = styled.div`
  margin-top: 20px;
`;

const HeaderButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;  
    flex-wrap: wrap;
`;

const HeaderText = styled.div`
    max-width: 500px;
`;


const LoadingWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SearchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1 1 auto;
    align-items: center;

    .filter-container {
        width: 100%;
    }
`;

const SearchSubmitWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
`;

const FilterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1 1 auto;
    align-items: center;

    .filter-container {
        width: 100%;
    }
`;

const FilterSubmitWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    z-index: 2;
`;

const TableHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;  
    flex-wrap: wrap;
`;

export default {
    ContainerHeader,
    HeaderButtons,
    HeaderWrapper,
    HeaderText,
    DashboardWrapper,
    DashboardBody,
    DashboardTable,
    FilterWrapper,
    FilterSubmitWrapper,
    LoadingWrapper,
    SearchWrapper,
    SearchSubmitWrapper,
    TableHeaderWrapper
};
